export default "__VITE_ASSET__39083053__"